import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const PhoneNumbersTable = (props) => {
  const { wabaId } = props;
  const [data, setData] = useState([]);
  const [paging, setPaging] = useState({ before: '', after: '' });

  useEffect(() => {
    if (props.data) {
      setData(props.data.data);
      setPaging(props.data.paging);
    }
  }, [props.data]);

  const columns = [
    {
      field: 'business_info',
      name: 'Business Information',
      flex: 1,
      selector: (row) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <strong>{row.verified_name}</strong>
          <div>Verification: {row.code_verification_status}</div>
        </div>
      ),
    },
    {
      field: 'contact',
      name: 'Contact Details',
      flex: 1,
      selector: (row) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div>ID: {row.id}</div>
          <div>Phone: {row.display_phone_number}</div>
        </div>
      ),
    },
    {
      field: 'status',
      name: 'Account Status',
      flex: 1,
      selector: (row) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div>
            Quality:
            <span
              style={{
                color: row.quality_rating === 'GREEN' ? 'green' : 'orange',
                fontWeight: 'bold',
                marginLeft: '4px',
              }}
            >
              {row.quality_rating}
            </span>
          </div>
          <div>Platform: {row.platform_type}</div>
          <div>Throughput: {row.throughput.level}</div>
        </div>
      ),
    },
    {
      field: 'webhook',
      name: 'Webhook',
      flex: 1.5,
      selector: (row) => (
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
          }}
        >
          {row.webhook_configuration.application}
        </div>
      ),
    },
    {
      field: 'onboarded_date',
      name: 'Onboarded Date',
      flex: 1,
      selector: (row) => (
        <div>
          {new Date(row.last_onboarded_time).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </div>
      ),
    },
    {
      name: 'Actions',
      flex: 1,
      selector: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Button as={Link} to={`/dashboard/whatsapp/phone-number-details/${wabaId}/${row.id}`}>
            View Details
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="mt-5">
      <h5>Associated Phone Numbers</h5>
      <div className="d-flex gap-2">
        <DataTable columns={columns} data={data} />
      </div>
    </div>
  );
};

export default PhoneNumbersTable;
